import { useMediaQuery } from "react-responsive";

export const useScreenType = () => {
  const is2Cols = useMediaQuery({ minWidth: 1200 });

  if (is2Cols) return "3-cols";

  return "1-cols";
};
